export const SIGN_UP_ACTION = "USER@SIGN_UP_ACTION";
export const SIGN_UP_ACTION_INIT = "USER@SIGN_UP_ACTION_INIT";
export const SIGN_UP_ACTION_SUCCESS = "USER@SIGN_UP_ACTION_SUCCESS";
export const SIGN_UP_ACTION_FAILED = "USER@SIGN_UP_ACTION_FAILED";

export const IS_COMPANY_NAME_EXIST_ACTION = "USER@IS_COMPANY_NAME_EXIST_ACTION";
export const IS_COMPANY_NAME_EXIST_INIT = "USER@IS_COMPANY_NAME_EXIST_INIT";
export const IS_COMPANY_NAME_EXIST_SUCCESS =
  "USER@IS_COMPANY_NAME_EXIST_SUCCESS";
export const IS_COMPANY_NAME_EXIST_FAILED = "USER@IS_COMPANY_NAME_EXIST_FAILED";

export const EMAIL_EXIST = "USER@EMAIL_EXIST";
export const EMAIL_EXIST_INIT = "USER@EMAIL_EXIST_INIT";
export const EMAIL_EXIST_SUCCESS = "USER@EMAIL_EXIST_SUCCESS";
export const EMAIL_EXIST_FAILED = "USER@EMAIL_EXIST_FAILED";

export const GET_INVESTOR_TYPE = "USER@GET_INVESTOR_TYPE";
export const GET_INVESTOR_TYPE_INIT = "USER@GET_INVESTOR_TYPE_INIT";
export const GET_INVESTOR_TYPE_SUCCESS = "USER@GET_INVESTOR_TYPE_SUCCESS";
export const GET_INVESTOR_TYPE_FAILED = "USER@GET_INVESTOR_TYPE_FAILED";

export const GET_STRATEGY_INIT = "USER@GET_STRATEGY_INIT";
export const GET_STRATEGY = "USER@GET_STRATEGY";
export const GET_STRATEGY_SUCCESS = "USER@GET_STRATEGY_SUCCESS";
export const GET_STRATEGY_FAILED = "USER@GET_STRATEGY_FAILED";

export const IS_COOPRATIVE_EMAIL = "USER@IS_COOPRATIVE_EMAIL";
export const IS_COOPRATIVE_EMAIL_INIT = "USER@IS_COOPRATIVE_EMAIL_INIT";
export const IS_COOPRATIVE_EMAIL_SUCCESS = "USER@IS_COOPRATIVE_EMAIL_SUCCESS";
export const IS_COOPRATIVE_EMAIL_FAILED = "USER@IS_COOPRATIVE_EMAIL_FAILED";

export const GET_FUND_TYPE = "GET@GET_FUND_TYPE";
export const GET_FUND_TYPE_INIT = "GET@GET_FUND_TYPE_INIT";
export const GET_FUND_TYPE_SUCCESS = "GET@GET_FUND_TYPE_SUCCESS";
export const GET_FUND_TYPE_FAILED = "GET@GET_FUND_TYPE_FAILED";
